//  For each product on the page
document.querySelectorAll('.productV3').forEach(section => {
    const product = JSON.parse(section.querySelector(".productV3JSON").textContent);
    let activeVariant = JSON.parse(section.querySelector(".activeVariantJSON").textContent);
    // product has subscription
    const hasSubscription = product.selling_plan_groups.length > 0;


    // during dev mode, set the active variant to the window so it can be accessed in the console
    if (Shopify.theme.role === "development") {
        window.productV3 = product;
        window.activeVariant = activeVariant;
    }

    /************
     Product Swiper
     ************/

    // for all the variant's swiper element
    if (section.querySelector('.productV3VisualSwiper')) {
        section.querySelectorAll('.productV3VisualSwiper').forEach(el => {
            const swiper = new Swiper(el, {
                slidesPerView: 1,
                spaceBetween: 20,
                autoHeight: true,
                pagination: {
                    el: el.querySelector(".swiper-pagination"),
                    clickable: true,
                }
            });

            // check for zoom and zoom amount
            const addZoom = section.querySelector('.productV3Visual').classList.contains('zoom');

            if (addZoom) {
                // get parent container
                const parentWrap = el.closest('.productV3VisualMainWrap');
                const zoomSwiperWindow = parentWrap.querySelector('.productV3VisualZoom')
                // pop up swiper
                const zoomSwiper = new Swiper(parentWrap.querySelector('.productV3VisualZoomSwiper'), {
                    slidesPerView: 1,
                    spaceBetween: 20,
                    speed: 0,
                    // autoHeight: true,
                    navigation: {
                        nextEl: parentWrap.querySelector(".swiper-button-next"),
                        prevEl: parentWrap.querySelector(".swiper-button-prev"),
                    },
                    zoom: {
                        maxRatio: 3,
                        toggle: false
                    },
                    on: {
                        slideChange: function () {
                            // update slide count
                            parentWrap.querySelector('.productV3VisualZoomSwiperNavigationDisplay span').textContent = String(this.activeIndex + 1);
                            // ensure zoom button is reset
                            parentWrap.querySelectorAll('.productV3VisualZoomSwiperNavigationEnhance')?.forEach(el => el.classList.remove('active'));
                        }
                    }
                });

                // listeners added to all zoom buttons
                parentWrap.querySelectorAll('.productV2VisualZoomButton')?.forEach((button, index) => {
                    // button sets swiper over clicked image, will transition out to full screen
                    button.addEventListener('click', function () {
                        const clickedImage = this.closest('.productV3VisualImageWrap').querySelector('img');
                        const clickedImagePosition = clickedImage.getBoundingClientRect();

                        // position over the image
                        zoomSwiperWindow.style.left = `${clickedImagePosition.left}px`;
                        zoomSwiperWindow.style.top = `${clickedImagePosition.top}px`;
                        zoomSwiperWindow.style.width = `${clickedImagePosition.width}px`;
                        zoomSwiperWindow.style.height = `${clickedImagePosition.height}px`;
                        zoomSwiperWindow.classList.add('animating');

                        // forces browser to recognize change
                        zoomSwiperWindow.getBoundingClientRect();

                        // start swiper on image and add back the speed
                        zoomSwiper.slideTo(index);
                        zoomSwiper.params.speed = 300;
                        zoomSwiper.update();

                        // browser will wait until applied css changes, smooths transition
                        requestAnimationFrame(() => {
                            zoomSwiperWindow.classList.remove('animating');
                            zoomSwiperWindow.style.transition = 'opacity 0.3s ease, transform 0.5s ease, left 0.5s ease, top 0.5s ease, width 0.5s ease, height 0.5s ease';
                            zoomSwiperWindow.style.transform = 'scale(1)';
                            zoomSwiperWindow.classList.add('active');
                            document.querySelector('body').classList.add('noScroll');
                        });
                    });

                })

                // button zooms and in/out
                parentWrap.querySelectorAll('.productV3VisualZoomSwiperNavigationEnhance')?.forEach(el => {
                    el.addEventListener('click', function () {
                        this.classList.contains('active') ? zoomSwiper.zoom.out() : zoomSwiper.zoom.in();
                        this.classList.toggle('active');
                    })
                })

                // close larger swiper and reset
                parentWrap.querySelector('.productV3VisualZoomSwiperClose').addEventListener('click', function () {
                    zoomSwiperWindow.removeAttribute('style');
                    zoomSwiperWindow.classList.remove('active');
                    document.querySelector('body').classList.remove('noScroll');
                    zoomSwiper.params.speed = 0;
                    zoomSwiper.update();
                });

            }
        })
        // if there is a swiper, check for a open zoom element on keydown esc
        if (section.querySelector('.productV3VisualZoomSwiper')) {
            document.addEventListener('keydown', function (e) {
                if (e.key === 'Escape') {
                    if (section.querySelector('.productV3VisualZoom.active')) {
                        section.querySelector('.productV3VisualZoom.active').classList.remove('active');
                        document.querySelector('body').classList.remove('noScroll');
                    }
                }
            })
        }
    }

    /**************
     Product Quantity
     ***************/

    // Read the selected quantity when it is needed rather than caching it at
    // load. Liquid marks the first block checked, but browsers also restore
    // radio state on a back-navigation, and the two can land in either order —
    // caching at init meant sometimes reading the server's choice and sometimes
    // the restored one. By the time anything asks, the DOM has settled.
    function quantity() {
        return parseInt(section.querySelector('.productV3FormQuantityItemInput:checked')?.value) || 1;
    }

    /**************
     Update Product
     ***************/

    function isSubscription() {
        return !!section.querySelector(`.productV3FormSellingOptionInput[value="sub"]:checked`);
    }

    function currentSellingPlan() {
        return parseInt(section.querySelector('.productV3FormSellingOptionPlan').value);
    }

    // update active variant on input changes
    section.querySelectorAll("input, select").forEach(function (element) {
        element.addEventListener("change", function () {
            updateProduct().catch(e => console.error(e));
        });
    })

    // update active variant on input changes
    section.querySelectorAll("input, select").forEach(function (element) {
        element.addEventListener("change", function () {
            // if subscribed, update the option selector
            if (hasSubscription && element.name.includes('choice')) {
                if (section.querySelector('.productV3FormSellingOptionInput ~ .productV3FormSellingOptionInner .productV3FormOptionsItemValuesLabelInput:checked')) {
                    const value = section.querySelector('.productV3FormSellingOptionInput ~ .productV3FormSellingOptionInner .productV3FormOptionsItemValuesLabelInput:checked').value;
                    section.querySelector(`.productV3FormSellingOptionInput ~ .productV3FormSellingOptionInner .productV3FormOptionsItemValuesLabelInput[value="${value}"]:not(:checked)`).click();
                }
            } else {
                updateProduct().catch(e => console.error(e));
            }
        });
    })

    async function updateProduct() {
        // Find the active variant
        if (product.variants.length === 1) {
            // default fallback
            activeVariant = product.variants[0];
        } else {
            // collect options from inputs
            let options = [];
            section.querySelectorAll(`.productV3FormOptionsItem`).forEach(group => {
                if (group.querySelector(`input:checked`)) {
                    options.push(group.querySelector(`input:checked`).value);
                }
            });

            // find new variant based on the options
            activeVariant = product.variants.find((variant) => {
                return JSON.stringify(variant.options) === JSON.stringify(options)
            });
        }

        // check if variant wasn't found
        if (!activeVariant) {
            section.querySelector(".productV3ATC").disabled = true;
            section.querySelector(".productV3ATCText").textContent = "Not Available";
            return;
        }

        // swap the variant images
        section.querySelectorAll('.productV3VisualMainWrap').forEach(el => {
            parseInt(el.dataset.id) === activeVariant.id ? el.classList.add('active') : el.classList.remove('active');
        })

        /**************
         Price
         ***************/

        // if there's a subscription we need to update both prices
        if (hasSubscription) {
            // Select both sets of elements at once
            const compares = section.querySelectorAll(".productV3FormSellingOptionHeaderPriceCompare");
            const reals = section.querySelectorAll(".productV3FormSellingOptionHeaderPriceReal");

            // Destructure them for clarity:
            // Assuming the markup is structured so that index 0 is for subscription, index 1 for one-time purchase
            const [subCompare, oneTimeCompare] = compares;
            const [subReal, oneTimeReal] = reals;

            const allocationPrice = activeVariant.selling_plan_allocations[0].price;

            // Update subscription prices
            if (activeVariant.price > allocationPrice) {
                subCompare.textContent = price(activeVariant.price * quantity());
            }
            subReal.textContent = price(allocationPrice * quantity());

            // Update one-time purchase prices
            if (activeVariant.compare_at_price > activeVariant.price) {
                oneTimeCompare.textContent = price(activeVariant.compare_at_price * quantity());
            }
            oneTimeReal.textContent = price(activeVariant.price * quantity());

        } else {
            // Non-subscription scenario
            const compareEl = section.querySelector(".productV3FormSellingOptionHeaderPriceCompare");
            const realEl = section.querySelector(".productV3FormSellingOptionHeaderPriceReal");

            if (activeVariant.compare_at_price > activeVariant.price) {
                compareEl.textContent = price(activeVariant.compare_at_price * quantity());
            }
            realEl.textContent = price(activeVariant.price * quantity());
        }

        /**************
         ATC Enable/Disable
         ***************/

        // check if the variant is in stock
        if (activeVariant.available) {
            section.querySelector(".productV3ATC").disabled = false;
            section.querySelector(".productV3ATCText").textContent = "Add To Cart";
        } else {
            section.querySelector(".productV3ATC").disabled = true;
            section.querySelector(".productV3ATCText").textContent = "Sold Out";
        }

        // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    updateProduct().catch(e => console.error(e));

    /**************
     Product ATC
     ***************/

    async function addToCart() {

        // add loading animation to both buttons
        section.querySelector(".productV3ATC").classList.add("loading");

        let formData = {
            items: [{
                quantity: quantity(),
                id: activeVariant.id,
            }]
        };

        // check for selling plan
        if (isSubscription()) {
            formData.items[0].selling_plan = currentSellingPlan();
        }

        // add product
        await addProduct(formData);

        // remove loading animation
        section.querySelector(".productV3ATC").classList.remove("loading");

        // open cart
        await openCart();
    }

    section.querySelector('.productV3ATC').addEventListener("click", addToCart);

});